import { Controller } from "@hotwired/stimulus"

// Coordina acciones desde dropdown items → modales/forms hermanos.
//
// Problema: el dropdown controller mueve su panel a <body>, desconectando
// los items del arbol DOM original. Stimulus actions no llegan a controllers
// que no son ancestros del elemento que dispara.
//
// Solucion: el dropdown controller tiene un delegated click handler en el
// menu node. Items con data-event disparan un CustomEvent en document.
// Este controller escucha ese evento y ejecuta openModal o submitForm.
//
// Uso en ERB:
//   <div data-controller="manage--outline-actions"
//        data-manage--outline-actions-id-value="drip_lock_42">
//     <%= dropdown(...) do %>
//       <%= dropdown_item "Goteo",
//         data: { event: "outline-action", target_id: "drip_lock_42",
//                 dispatch_action: "openModal", modal: "drip" } %>
//     <% end %>
//     <div data-manage--outline-actions-target="drip"
//          data-controller="manage--modal" style="display:contents">
//       <%= modal_dialog(...) %>
//     </div>
//   </div>
export default class extends Controller {
  static values = { id: String }

  connect() {
    this._handler = this._handleEvent.bind(this)
    document.addEventListener("outline-action", this._handler)
  }

  disconnect() {
    document.removeEventListener("outline-action", this._handler)
  }

  _handleEvent(event) {
    const { targetId, dispatchAction, modal, formId } = event.detail
    if (targetId !== this.idValue) return

    if (dispatchAction === "openModal" && modal) {
      this._openModal(modal)
    } else if (dispatchAction === "submitForm" && formId) {
      this._submitForm(formId)
    }
  }

  _openModal(name) {
    const el = this.element.querySelector(
      `[data-manage--outline-actions-target="${name}"]`
    )
    if (!el) return

    const ctrl = window.Stimulus.getControllerForElementAndIdentifier(el, "manage--modal")
    if (ctrl) ctrl.open()
  }

  _submitForm(id) {
    const form = document.getElementById(id)
    if (form) form.requestSubmit()
  }
}
